import { type UiLibI18n } from '@myre/domain-i18n-wordings';

import { Component, computed, inject, input, output } from '@angular/core';

import { WORDINGS } from '../../../myre-wordings-loader';

@Component({
  selector: 'app-unread-indicator',
  standalone: true,
  template: `
    <div class="unread-indicator" (click)="scrollRequested.emit()">
      <span class="unread-badge">{{ count() }}</span>
      <span class="unread-text">{{ unreadText() }}</span>
      <span class="unread-arrow">↓</span>
    </div>
  `,
  styles: [
    `
      .unread-indicator {
        position: sticky;
        bottom: 1rem;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.75rem 1.25rem;
        background-color: var(--color-ui-green-500);
        color: var(--color-ui-white-100);
        border-radius: 24px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        cursor: pointer;
        transition: all 0.2s ease;
        z-index: 10;
        font-size: 0.9rem;
        font-weight: 500;
        user-select: none;
        width: fit-content;
        margin: 0 auto;
      }

      .unread-indicator:hover {
        background-color: var(--color-ui-green-900);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
        transform: translateX(-50%) translateY(-2px);
      }

      .unread-indicator:active {
        transform: translateX(-50%) translateY(0);
      }

      .unread-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 1.5rem;
        height: 1.5rem;
        padding: 0 0.4rem;
        background-color: rgba(255, 255, 255, 0.3);
        border-radius: 12px;
        font-size: 0.85rem;
        font-weight: 600;
      }

      .unread-text {
        font-size: 0.9rem;
      }

      .unread-arrow {
        font-size: 1.2rem;
        animation: bounce 1s infinite;
      }

      @keyframes bounce {
        0%,
        100% {
          transform: translateY(0);
        }
        50% {
          transform: translateY(3px);
        }
      }
    `,
  ],
})
export class UnreadIndicatorComponent {
  private readonly _wordings = inject<UiLibI18n>(WORDINGS);

  public readonly count = input.required<number>();

  public readonly scrollRequested = output<void>();

  protected get chatWordings() {
    return this._wordings._library.chat;
  }

  protected readonly unreadText = computed(() =>
    this.count() > 1
      ? this.chatWordings.newMessages()
      : this.chatWordings.newMessage(),
  );
}
